import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class AiInspectionPlushieInspectionDraft
  implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(
    private fId: string,
    private fPlushieId: string,
    private fQaGroupNumber: number,
    private fComment: string
  ) {
    [fId, fPlushieId, fQaGroupNumber, fComment].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });

    if (!Number.isFinite(fQaGroupNumber)) {
      throw new Error("QA group number must be a finite number");
    }
  }

  get id(): string {
    return this.fId;
  }

  get plushieId(): string {
    return this.fPlushieId;
  }

  get qaGroupNumber(): number {
    return this.fQaGroupNumber;
  }

  get comment(): string {
    return this.fComment;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }
}
